import React, { useEffect, useState } from "react";
import { setKey, setStringifiedKey } from "../store/actions";
import { connect } from "react-redux";
import CountriesDropdown from "./CountriesDropdown";
import keys from "../store/keys";

function DeliveryAddress({ session, setKey, ...props }) {

	const [countryId, setCountryId] = useState(session.user.countryId);
	const [firstname, setFirstname] = useState(session.user.d_firstname);
	const [lastname, setLastname] = useState(session.user.d_lastname);
	const [line1, setLine1] = useState(session.user.line1);
	const [line2, setLine2] = useState(session.user.line2);
	const [city, setCity] = useState(session.user.city);
	const [country, setCountry] = useState(session.user.country);
	const [postcode, setPostcode] = useState(session.user.postcode);
	const [phone, setPhone] = useState(session.user.phone);

	useEffect(() => {
		if(props.onChange) {
			let obj = { countryId, firstname, lastname, line1, line2, city, country, postcode, phone };
			props.onChange(obj);
		}
	}, [countryId, firstname, lastname, line1, line2, city, country, postcode, phone]);


	return (
		<div className="container delivery-address">
			<p className="cart-title">Delivery Address</p>
			<div className="row">
				<div className="col">
					<label className="form-label">Country/Region*</label>
					<CountriesDropdown preselected={countryId} selectedCountry={setCountryId} />
				</div>
				<div className="col"></div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">First Name*</label>
					<input type="text" className="form-control shadow-none" value={firstname} onChange={e => setFirstname(e.target.value)} />
				</div>
				<div className="col">
					<label className="form-label">Last Name*</label>
					<input type="text" className="form-control shadow-none" value={lastname} onChange={e => setLastname(e.target.value)} />
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">Address Lane 1*</label>
					<input type="text" className="form-control shadow-none" value={line1} onChange={e => setLine1(e.target.value)} />
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">Address Lane 2</label>
					<input type="text" className="form-control shadow-none" value={line2} onChange={e => setLine2(e.target.value)} />
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">City*</label>
					<input type="text" className="form-control shadow-none" value={city} onChange={e => setCity(e.target.value)} />
				</div>
				<div className="col">
					<label className="form-label">Country</label>
					<input type="text" className="form-control shadow-none" value={country} onChange={e => setCountry(e.target.value)} />
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">Postcode*</label>
					<input type="text" className="form-control shadow-none" value={postcode} onChange={e => setPostcode(e.target.value)} />
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<label className="form-label">Daytime Phone*</label>
					<input type="text" className="form-control shadow-none" value={phone} onChange={e => setPhone(e.target.value)} />
				</div>
			</div>
			
			<div className="row">
				<div className="col">
					{props.errorMessage && <div className="text-danger mb-2">{props.errorMessage}</div>}
					{props.successMessage && <div className="text-success mb-2">{props.successMessage}</div>}
				</div>
			</div>
			{
				props.showButton === true &&
				<div className="row mt-10 text-end">
					<div className="col">

						<button
							type="submit"
							className="btn btn-dark shadow-none mt-10 mb-3"
							onClick={props.handleSubmit}>
							Save Changes
						</button>
					</div>
				</div>
			}
		</div>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryAddress);
